import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import {ref} from "vue";
import RepositoryFactory from "@/factories/RepositoryFactory";
import Work from "@/models/Work";
import CSection from "@/components/section/CSection.vue";
import CSectionSubtitle from "@/components/section/CSectionSubtitle.vue";
import CSectionTitle from "@/components/section/CSectionTitle.vue";
import CSectionText from "@/components/section/CSectionText.vue";
import CWorkList from "@/components/my-works/CWorkList.vue";
import CWorkCard from "@/components/my-works/CWorkCard.vue";
import CSectionOneColumn from "@/components/section/CSectionOneColumn.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CMyWorks',
  setup(__props) {

const works = ref<Array<Work>>([])

RepositoryFactory
  .default()
  .getWorks()
  .then(data => works.value = data)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CSectionOneColumn, {
    class: "blog",
    subtitle: _ctx.$t('my-works-title'),
    title: _ctx.$t('my-works-quote'),
    text: _ctx.$t('my-works-description'),
    id: "my-works"
  }, {
    default: _withCtx(() => [
      _createVNode(CWorkList, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(works.value, (work, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(CWorkCard, { work: work }, null, 8, ["work"])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["subtitle", "title", "text"]))
}
}

})